import React from 'react';
import { how_it_works } from '../../utils/home';
import { Row, Col } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import SEO from '../../components/SEO';
const HowItWork = () => {
    return (
        <div className="howItWorksContainer">
            <SEO
                title="How Easy Lease Works"
                description="One-Stop Transport & Finicial Solution"
                path="how-it-works"
            />
            <h2 className="sectionTitle">How Easy Lease Works</h2>
            <Row justify="center" gutter={48} className="heroContainerQuickTips">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 8 }}
                    xl={{ span: 6 }}
                    xxl={{ span: 6 }}
                >
                    <h3 class="captionText">
                        <CheckOutlined className="heroContainerQuickTipsIcon" /> One flat monthly payment
                    </h3>
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 8 }}
                    xl={{ span: 6 }}
                    xxl={{ span: 6 }}
                >
                    <h3 class="captionText">
                        <CheckOutlined className="heroContainerQuickTipsIcon" /> Cars for 6-36 months
                    </h3>
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 8 }}
                    xl={{ span: 6 }}
                    xxl={{ span: 6 }}
                >
                    <h3 class="captionText">
                        <CheckOutlined className="heroContainerQuickTipsIcon" /> All-inclusive pricing
                    </h3>
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 8 }}
                    xl={{ span: 6 }}
                    xxl={{ span: 6 }}
                >
                    <h3 class="captionText">
                        <CheckOutlined className="heroContainerQuickTipsIcon" /> Fast delivery
                    </h3>
                </Col>
            </Row>

            <Row justify="center" gutter={48}>
                {how_it_works.map((item, key) => (
                    <Col
                        key={key}
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="howItWorksBlocks"
                    >
                        <img className="how-it-works-image" src={item.image} alt={item.title} />
                        <br />
                        <h3 className="blockTitle text-center">{item.title}</h3>
                        <p className="blockPara text-center">{item.description}</p>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default HowItWork;
